import { connect } from 'react-redux'
import AdminNoClasses from './component'
import NavigationHelper from 'layers/navigation/navigationHelper'

export default connect(
  null,
  NavigationHelper.mapDispatchToProps,
)(AdminNoClasses)
